const ProjectDetailInfo = ({ projectDetails, onImageClick }) => {
  return (
    <>
      <div className="px-10 mt-10 grid grid-cols-12 gap-20">
        <div className="col-span-8 flex flex-col gap-6">
          <h1 className="text-2xl font-semibold">Description</h1>
          <span className="text-md">{projectDetails.ProjectDescription}</span>
          <h1 className="text-2xl font-semibold">Concept</h1>
          <span className="text-md">{projectDetails.Concept}</span>
          <h1 className="text-2xl font-semibold">Innovations</h1>
          <span className="text-md">{projectDetails.Innovation}</span>
          <div className="flex flex-col gap-5 mb-10">
            {projectDetails.Image2 && (
              <img
                src={projectDetails.Image2}
                alt="Concept/Innovation 2"
                className="cursor-pointer hover:opacity-95 transition-opacity rounded-lg"
                onClick={() => onImageClick && onImageClick(projectDetails.Image2)}
              />
            )}
            {projectDetails.Image3 && (
              <img
                src={projectDetails.Image3}
                alt="Concept/Innovation 3"
                className="cursor-pointer hover:opacity-95 transition-opacity rounded-lg"
                onClick={() => onImageClick && onImageClick(projectDetails.Image3)}
              />
            )}
            {projectDetails.Image4 && (
              <img
                src={projectDetails.Image4}
                alt="Concept/Innovation 4"
                className="cursor-pointer hover:opacity-95 transition-opacity rounded-lg"
                onClick={() => onImageClick && onImageClick(projectDetails.Image4)}
              />
            )}
            {projectDetails.Image5 && (
              <img
                src={projectDetails.Image5}
                alt="Concept/Innovation 5"
                className="cursor-pointer hover:opacity-95 transition-opacity rounded-lg"
                onClick={() => onImageClick && onImageClick(projectDetails.Image5)}
              />
            )}
          </div>  
        </div>
     
      </div>
    </>
  );
};

export default ProjectDetailInfo;
